import Icon from 'shopper/components/Icon';

const WhatsAppBanner = () => (
  <div className="dark:to-primary-600 overflow-hidden rounded-3 bg-gradient-to-br from-primary-300 to-primary-500 p-4 dark:from-primary-400">
    <p className="mb-3 text-sm font-bold leading-snug text-neutral-high-100">
      Receba as melhores ofertas direto no seu WhatsApp
    </p>
    <div className="mb-4 flex h-24 items-center justify-center">
      <div className="bg-white/20 flex h-20 w-12 items-center justify-center rounded-2">
        <Icon
          className="text-neutral-high-100"
          name="phone-android"
          size="size1"
        />
      </div>
    </div>
    <a
      className="text-white flex w-full items-center justify-center gap-x-2 rounded-3 bg-[#25D366] px-4 py-2 text-sm font-bold transition-opacity hover:opacity-90"
      href="https://whatsapp.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Icon name="whatsapp" size="size3" />
      Entre Agora
    </a>
  </div>
);

export default WhatsAppBanner;
